import { BaseHook } from './base.hook';

export class AccountTypeHook extends BaseHook {
  static path = 'ApplicationInformation.accountType';

  static execute(path, value, actions) {
    const domainsToCrush = [
      { path: 'GoalInformation', review: '/investment-objective' },
      { path: 'TrustedContact', review: '/trusted-contact' },
      {
        path: 'JointAccountFinancialInformation',
        review: '/joint-financial-info',
      },
      { path: 'JointAccountInformation', review: '/joint-info' },
      { path: 'CustodialMinorInformation', review: '/custodial-minor-info' },
      { path: 'BeneficiaryInformation', review: '/edit-beneficiary-info' },
    ];

    for (const d of domainsToCrush) {
      actions.deleteData(d.path);
      if (d.review !== undefined) actions.clearData(`review.${d.review}`);
    }
  }
}
